export const nextArrow =
    `<button class="next">
        <svg class="chevron" width="30" height="30" viewBox="0 0 0.6 0.6" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(90deg)">
            <path clip-rule="evenodd" d="m0.3 0.294 0.172 0.172 0.106 -0.106L0.3 0.081 0.022 0.359l0.106 0.106L0.3 0.294Z" fill="currentColor" fill-rule="evenodd" />
        </svg>
    </button>`;

export const prevArrow =
    `<button class="prev">
        <svg class="chevron" width="30" height="30" viewBox="0 0 0.6 0.6" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(-90deg)">
            <path clip-rule="evenodd" d="m0.3 0.294 0.172 0.172 0.106 -0.106L0.3 0.081 0.022 0.359l0.106 0.106L0.3 0.294Z" fill="currentColor" fill-rule="evenodd" />
        </svg>
    </button>`;

export const slickDefaults = {

};